
namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class StockItemSelectGrid extends _Ext.GridBase<StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return StockItemRow.localTextPrefix; }
        protected getService() { return StockItemService.baseUrl; } 
      
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        get selectedItems(): StockItemRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;
           
        }
        
    } 
}